<template>
  <div class="screen-main">
    <div class="main-left">
      <div class="maintain-record" v-screen-loading="calendarLoading">
        <div class="title">
          <div class="change">
            <div class="tip">
              <p>
                <span class="en-class">{{ $l("无纸化保养记录") }}</span>
              </p>
            </div>
            <div class="btn">
              <svgicon name="date-left" @click="changeDate(0)" />
              <span
                >{{ calenderDate.y + "." + calenderDate.m }}
                <el-date-picker
                  prefix-icon="none"
                  :clearable="false"
                  class="custom-date-picker"
                  v-model="datePickerValue"
                  popper-class="date-screen"
                  :append-to-body="false"
                  type="month"
                  placeholder=""
                  @change="changeCalenderDate"
                >
                </el-date-picker
              ></span>
              <svgicon name="date-right" @click="changeDate(1)" />
            </div>
          </div>
          <div class="already">
            <span>
              <svgicon name="date-legend" />
              {{ $l("已完成") }}
            </span>
            <span>
              <svgicon name="date-legend" />
              {{ $l("未完成") }}
            </span>
          </div>
        </div>
        <div class="calendar">
          <div class="calendar-title">
            <span v-for="item in calendarTitle" :key="item">{{ item }}</span>
          </div>
          <div class="calendar-table">
            <div
              class="calendar-item"
              v-for="(item, index) in calenderDate.ds"
              :key="index"
              :class="[
                item.notNow ? 'ash' : '',
                calenderDate.y + calenderDate.m + item.dZero == calenderDate.activateDate && !item.notNow
                  ? 'activate'
                  : '',
              ]"
            >
              <i>{{ item.d }}</i>
              <span>
                <em>{{ item.planOrFinish[0] | maintainRecordSimplify }}/</em
                >{{ item.planOrFinish[1] | maintainRecordSimplify }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="degree-pie">
        <div class="tip tip-plus">
          <p>
            <span class="en-class">{{ $l("运行次数分布统计") }}</span>
          </p>
        </div>
        <div class="pie">
          <div id="degree-pie-id" class="pie-box"></div>
          <div class="degree-label">
            <div v-for="(item, index) in runTimePieData" :key="index">
              <span> <i :style="{ backgroundColor: item.itemStyle.color }"></i>{{ $l(item.name) }}</span>
              <span>
                <em>{{ item.value | maintainRecordSimplify("0000") }}</em>
                {{ $l("台") }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="device-state">
        <div class="tip tip-plus">
          <p>
            <span class="en-class">{{ $l("遥监设备状态") }}</span>
          </p>
        </div>
        <div class="percentage">
          <div class="item-normal">
            <div>
              <span
                ><i>{{ $l("正常") }} </i><s>{{ monitorStatusData.normal.centage }}</s></span
              >
              <span
                ><i>{{ $l("监视") }} </i><s>{{ monitorStatusData.normal.value }}</s></span
              >
            </div>
          </div>
          <div class="item-abnormal">
            <div>
              <span
                ><i>{{ $l("异常") }} </i><s>{{ monitorStatusData.abnormal.centage }}</s></span
              >
              <span
                ><i>{{ $l("监视") }} </i><s>{{ monitorStatusData.abnormal.value }}</s></span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="monitoring-top">
        <div class="tip tip-plus">
          <p>
            <span class="en-class">{{ $l("昨日遥监预警记录排行") }}</span>
          </p>
        </div>
        <div class="top-list">
          <template v-if="monitorWarningTop3.length != 0">
            <div v-for="(item, index) in monitorWarningTop3" :key="item.domainId">
              <em>TOP{{ index + 1 }}</em>
              <span>{{ item.city }}.{{ $l("故障台量") }} {{ item.liftCount }}{{ $l("台") }} {{ item.domainName }}</span>
              <i>{{ item.faultCount }}{{ $l("宗") }} </i>
            </div></template
          >
          <template v-else>
            <div class="no-data">
              <p>{{ warningtopLoading | emptyOrLoadText($l) }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="main-map">
      <div class="map-fbox" v-screen-loading="mapLoading">
        <div id="tiring-map-box">
          <span class="map-under" v-if="mapMaintain">{{ $l("地图维护中...") }} </span>
        </div>
        <div class="warning-list-box">
          <el-collapse-transition>
            <div class="suspension" @click="openShowWarning" v-show="!showWarnings">
              <span>{{ $l("预警数") }} </span>
            </div>
          </el-collapse-transition>
          <el-collapse-transition>
            <div class="warning-map-list" v-show="showWarnings">
              <div class="tip">
                <p>
                  <span class="en-class">{{ $l("预警数") }}</span>
                </p>
              </div>
              <div class="warning-list">
                <my-seamless-scroll
                  class="seamless-warning"
                  ref="warningScroll"
                  :data="mapAllScrollData"
                  :class-option="{
                    step: 0.5,
                    limitMoveNum: 16,
                    hoverStop: true,
                    openWatch: true,
                    singleHeight: singleMapHeight,
                  }"
                >
                  <div class="warning-map-item" v-for="(item, index) in mapAllCicyData" :key="index">
                    <label>{{ item.name }}</label>
                    <span>：{{ item.value }}{{ $l("台") }} </span>
                  </div>
                </my-seamless-scroll>
              </div>
              <div class="footer">
                <i @click="cancelShowWarning"></i>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <div class="tiring-map-label" v-if="!mapMaintain">
          <div class="tiring">
            <span>
              <svgicon name="tiring" />
            </span>
            <label>{{ $l("困人") }} </label>
          </div>
          <div class="warning">
            <span>
              <svgicon name="warning" />
            </span>
            <label>{{ $l("预警") }} </label>
          </div>
        </div>
      </div>
      <div class="rescue-progress">
        <div class="tip tip-plus-bottom">
          <p>
            <span class="en-class">
              {{ $l("今日救援进度统计") }}
            </span>
          </p>
        </div>
        <div class="rescue-view">
          <div class="rescue-items">
            <div class="tip tip-plus">
              <p>
                <span class="en-class">
                  {{ $l("故障维修进度") }}
                </span>
              </p>
            </div>
            <div class="progress-box">
              <div class="bar-box" v-for="(item, index) in rescueProgress.maintain.number" :key="index">
                <div class="progress-bar">
                  <screen-circle :config="circleConfig" :rate="rescueProgress.maintain.progress[index]">
                    <span>{{ rescueProgress.maintain.progress[index] | progressDecimals }}</span>
                  </screen-circle>
                </div>
                <div class="decorate"></div>
                <div class="text">
                  {{ $l(progressText[index]) }}
                  <em>{{ item }}</em>
                </div>
              </div>
            </div>
          </div>
          <div class="rescue-items">
            <div class="tip tip-plus">
              <p>
                <span class="en-class">
                  {{ $l("困人救援进度") }}
                </span>
              </p>
            </div>
            <div class="progress-box">
              <div class="bar-box" v-for="(item, index) in rescueProgress.rescue.number" :key="index">
                <div class="progress-bar">
                  <screen-circle :config="circleConfig" :rate="rescueProgress.rescue.progress[index]">
                    <span>{{ rescueProgress.rescue.progress[index] | progressDecimals }}</span>
                  </screen-circle>
                </div>
                <div class="decorate"></div>
                <div class="text">
                  {{ $l(progressText[index]) }}
                  <em>{{ item }}</em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-right">
      <div class="tour-collect">
        <div class="tip tip-plus tip-right">
          <p>
            <span class="en-class">
              {{ $l("设备巡视汇总") }}
            </span>
            <span
              >{{ $l("单位：") }} <i>{{ $l("台") }} </i></span
            >
          </p>
        </div>
        <div class="collect-list">
          <div class="collect-item" v-for="item in deviceCollects" :key="item.icon">
            <div
              class="icon"
              :style="{
                backgroundImage: `url(${require(`../../assets/img/largeScreen/${item.icon}.png`)})`,
              }"
            ></div>
            <div class="number">
              <span :data-title="$l(item.title)"></span>
              <em> <count-to :startVal="0" :endVal="item.number" :duration="3000" :decimals="0"> </count-to></em>
            </div>
          </div>
        </div>
      </div>
      <div class="liftage-distribute">
        <div class="tip tip-plus tip-right">
          <p>
            <span class="en-class">
              {{ $l("梯龄分布") }}
            </span>
            <span
              >{{ $l("单位：") }} <i>{{ $l("台") }} </i></span
            >
          </p>
        </div>
        <div class="liftage-custom-box" id="liftage-custom-box"></div>
      </div>
      <div class="realtime-info">
        <div class="tip tip-plus">
          <p>{{ $l("实时关注信息") }}</p>
        </div>
        <div class="info-list">
          <!-- :key="`seamless-scroll-${singleRealtimeHeight}`" -->
          <my-seamless-scroll
            class="seamless-warp"
            ref="realtimeScroll"
            :data="realTimeFollowList"
            :class-option="{
              step: 0.5,
              limitMoveNum: 1,
              hoverStop: true,
              openWatch: false,
              singleHeight: singleRealtimeHeight,
            }"
          >
            <div class="realtime-info-item" v-for="item in realTimeFollowList" :key="item.id">
              <template v-if="item.type == 1">
                <div>
                  {{ item.city || "--" }}
                  {{ item.domainName || "--" }} {{ item.jobNum }} {{ $l("于") }}
                  {{ item.time }}
                  {{ item.remove ? $l("一宗故障停梯消除") : $l("发生故障停梯") }}
                  <span>{{ item.updateTime }}</span>
                </div>
              </template>
              <template v-else-if="item.type == 2">
                <div>
                  {{ item.city || "--" }}
                  {{ item.domainName || "--" }} {{ item.jobNum }} {{ $l("于") }}
                  {{ item.time }}
                  {{ item.remove ? $l("完成困人救援") : $l("发生困人") }}
                  <span>{{ item.updateTime }}</span>
                </div></template
              >
              <template v-else-if="item.type == 3">
                <div>
                  {{ item.city || "--" }}
                  {{ item.domainName || "--" }} {{ item.jobNum }} {{ $l("于") }}{{ item.time }}
                  {{ item.remove ? $l("恢复正常") : $l("掉线") }}
                  <span>{{ item.updateTime }}</span>
                </div></template
              >
            </div>
          </my-seamless-scroll>
        </div>
      </div>
      <div class="monitoring-top monitoring-top-right">
        <div class="tip tip-plus tip-right">
          <p>
            {{ $l("合同提醒") }}

            <span
              >{{ $l("时间：") }} <i>{{ $l("三个月内") }} </i></span
            >
          </p>
        </div>
        <div class="top-list top-list-contract">
          <template v-if="contractRemindList.length != 0">
            <div v-for="(item, index) in contractRemindList" :key="index">
              <span>
                <s>{{ item.agreeNum }}·{{ item.city || "--" }}·{{ item.domainName || "--" }}</s>
                <em>·{{ $l("电梯") }} {{ item.utils }}{{ $l("台") }} </em>
              </span>
              <i>{{ item.days }}{{ $l("天") }} </i>
            </div>
          </template>
          <template v-else>
            <div class="no-data">
              <p>{{ contractLoading | emptyOrLoadText($l) }}</p>
            </div>
          </template>
        </div>
      </div>
      <div class="monitoring-top monitoring-top-right">
        <div class="tip tip-plus tip-right">
          <p class="en-end">
            <span>
              {{ $l("年检提醒") }}
            </span>
            <span
              >{{ $l("时间：") }} <i>{{ $l("三个月内") }} </i></span
            >
          </p>
        </div>
        <div class="top-list top-list-contract top-list-annual">
          <template v-if="annualExamineRemindList.length != 0">
            <div v-for="item in annualExamineRemindList" :key="item.domainId">
              <span>
                <s>{{ item.city || "--" }}</s>
                <em>{{ item.domainName || "--" }}</em>
              </span>
              <i>{{ item.utils }}{{ $l("台") }} </i>
            </div>
          </template>
          <template v-else>
            <div class="no-data">
              <p>{{ annualLoading | emptyOrLoadText($l) }}</p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../plugins/directive.js";
import ScaleBox from "vue2-scale-box";
import * as echarts from "echarts";
import dayjs from "dayjs";
import global from "@/mixins/global.js";
import screenCircle from "../../components/screenCircle.vue";
import "../../../node_modules/echarts/map/js/china.js";
import MySeamlessScroll from "../../components/mySeamlessScroll.vue";
import countTo from "vue-count-to";
export default {
  name: "largeScreen",
  mixins: [global],
  props: {
    screenWidth: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      datePickerValue: null,
      calenderDate: {
        y: null,
        m: null,
        d: null,
        ds: [],
      },
      calendarTitle: ["Sun/日", "Mon/一", "Tue/二", "Wed/三", "Thu/四", "Fri/五", "Sat/六"],
      mapMaintain: false,
      runTimePieData: [
        { value: 0, name: "0-50万次", itemStyle: { color: "#1DA7C0" } },
        {
          value: 0,
          name: "50-100万次",
          itemStyle: { color: "#F67B44" },
        },
        {
          value: 0,
          name: "100-150万次",
          itemStyle: { color: "#01CFA1" },
        },
        {
          value: 0,
          name: "150-200万次",
          itemStyle: { color: "#CECE41" },
        },
        {
          value: 0,
          name: "200万次以上",
          itemStyle: { color: "#7279ff" },
        },
        { value: 0, name: "未知", itemStyle: { color: "#F2F2E8" } },
      ],
      calendarLoading: false,
      pieChart: null,
      circleConfig: {
        borderWidth: "0.3vw",
        circleSize: "0",
        startColor: "#1DA7C0",
        endColor: "#C5FF87",
        centerCircleBg: "#000d2c",
        borderBackground: "#517698",
      },
      rescueProgress: 0.4,
      deviceCollects: [
        { icon: "collectRegularIcon", type: 1, title: "正常运行", number: 0 },
        {
          icon: "collectMonitoringIcon",
          type: 2,
          title: "遥监在线",
          number: 0,
        },
        { icon: "collectMaintainIcon", type: 3, title: "检修", number: 0 },
        { icon: "collectFaultIcon", type: 4, title: "故障停梯", number: 0 },
        { icon: "collectTiringIcon", type: 5, title: "困人", number: 0 },
        { icon: "collectIpkeepIcon", type: 0, title: "今日保养", number: 0 },
      ],
      liftageChart: null,
      tiringMapChart: null,
      showWarnings: true,
      lll: "indexBigScreen",
      monitorStatusData: {
        normal: { centage: "0%", value: "0" },
        abnormal: { centage: "0%", value: "0" },
      },
      monitorWarningTop3: [],
      contractRemindList: [],
      annualExamineRemindList: [],
      realTimeFollowList: [],
      singleRealtimeHeight: 0,
      singleMapHeight: 0,
      liftageData: [],
      mapWarningData: [],
      mapTiringData: [],
      mapAllCicyData: [],
      mapAllScrollData: [],
      mapViewType: {
        name: "全国",
        code: "china",
      },
      mapLoading: false,
      rescueProgress: {
        maintain: {
          number: [0, 0, 0, 0],
          progress: [0, 0, 0, 0],
        },
        rescue: {
          number: [0, 0, 0, 0],
          progress: [0, 0, 0, 0],
        },
      },
      warningtopLoading: false,
      contractLoading: false,
      annualLoading: false,
      throttleTimer: null,
      progressText: ["已报修", "已派工", "已到场", "已完工"],
    };
  },
  components: {
    ScaleBox,
    screenCircle,
    MySeamlessScroll,
    countTo,
  },
  computed: {},
  filters: {
    maintainRecordSimplify(number, str) {
      number = Number(number);
      let units = [1, 2, 3, 4, 5, 6, 7, 8, 9];
      function num(numstr) {
        let n = "1";
        units.forEach((v) => {
          if (number > v + numstr) {
            n = v;
          }
        });
        return n;
      }
      if (str == "0000") {
        let b = number / 10000;
        return b < 1 ? number : b > 1 ? (parseInt(b, 10) != b ? `${parseInt(b, 10)}w+` : `${b}w`) : `${b}w`;
      }
      return number > 9999 ? `${num("0000")}w+` : number > 999 ? `${num("000")}k+` : number;
    },
    progressDecimals(decimals) {
      return (decimals * 100).toFixed(0) + "%";
    },
    emptyOrLoadText(load, $l) {
      return load ? $l("加载中...") : $l("暂无数据");
    },
  },
  created() {},
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.calenderDate = this.$common.getCurrentOrRestDate();
      console.log(this.calenderDate);
      this.statisticsMonitorStatusCount();
      this.getMonitorWarningTop();
      this.getDeviceTourData();
      this.getContractRemind();
      this.getAnnualExamineRemind();
      this.getRealTimeFollowList();
      this.getLiftageData();
      this.getWarningandTiringMapData();
      this.getDateMaintainRecordDate();
      this.getRescueProgressData();
      this.getRunTimeStatData();
    },
    $browserWidthChange() {
      this.getFollowItemScrollHeight();
      this.pieChart && this.pieChart.resize();
      this.liftageChart && this.setLiftageCustomData(true);
      this.tiringMapChart && this.setTiringMapRender(true);
    },
    transformFontSize(fontsize) {
      const width = this.screenWidth;
      const ratio = width / 1920;
      return parseInt(fontsize * ratio);
    },
    /* getCurrentOrRestDate(date) {
      date = date || dayjs();
      function addZero(num) {
        if (num < 10 && num > 0) {
          return "0" + num;
        } else return num;
      }
      function getMonths(date, originalDate) {
        originalDate = originalDate || date;
        let daysInMonth = date.daysInMonth();
        let arrDays = [];
        while (daysInMonth) {
          let current = dayjs(
            String(date.$y) + addZero(date.$M + 1) + addZero(daysInMonth)
          );
          arrDays.push({
            planOrFinish: [0, 0],
            date: current.format("YYYY-MM-DD"),
            dZero: addZero(current.$D),
            d: String(current.$D),
            w: String(current.$W),
            notNow: date.$y + date.$M != originalDate.$y + originalDate.$M,
          });
          daysInMonth--;
        }
        return arrDays.reverse();
      }
      function getDaysArrayByMonth(date) {
        const themonth = getMonths(date);
        let lacknum = themonth[0].w;
        if (lacknum != 0) {
          let lastmonth = getMonths(date.add(-1, "months"), date);
          for (let i = 0; i < lacknum; i++) {
            themonth.unshift(lastmonth[lastmonth.length - 1 - i]);
          }
        }
        if (themonth.length < 6 * 7) {
          let little = 6 * 7 - themonth.length;
          let proximo = getMonths(date.add(1, "months"), date);
          for (let i = 0; i < little; i++) {
            themonth.push(proximo[i]);
          }
        }
        return themonth;
      }
      return {
        y: String(date.year()),
        m: addZero(date.month() + 1),
        d: addZero(date.date()),
        ds: getDaysArrayByMonth(date),
        activateDate: dayjs().format("YYYYMMDD"),
        $DATE: date,
      };
    }, */
    setRunTimePieData() {
      let chartDom = document.getElementById("degree-pie-id");
      this.pieChart = this.pieChart || echarts.init(chartDom);
      let option = {
        tooltip: {
          show: true,
          trigger: "item",
          confine: true,
        },
        series: [
          {
            name: "",
            type: "pie",
            radius: ["75%", "100%"],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              disabled: false,
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: this.runTimePieData,
          },
        ],
      };
      option && this.pieChart.setOption(option);
    },
    changeCalenderDate(date) {
      this.calenderDate = this.$common.getCurrentOrRestDate(dayjs(date));
      this.getDateMaintainRecordDate();
    },
    changeDate(step) {
      if (step) {
        this.calenderDate = this.$common.getCurrentOrRestDate(this.calenderDate.$DATE.add(1, "months"));
        this.getDateMaintainRecordDate();
      } else {
        this.calenderDate = this.$common.getCurrentOrRestDate(this.calenderDate.$DATE.add(-1, "months"));
        this.getDateMaintainRecordDate();
      }
      this.datePickerValue = this.calenderDate.$DATE.$d;
    },
    setLiftageCustomData(resize) {
      let unit = this.$l("台");
      let dataArr = [
        this.$l("0~3年"),
        this.$l("3~6年"),
        this.$l("6~10年"),
        this.$l("10~15年"),
        this.$l("15年以上"),
        this.$l("未知"),
      ];
      dataArr = dataArr.map((t, i) => {
        return {
          name: t,
          // code:
          num: this.liftageData[i],
        };
      });
      let TData = dataArr.map((item) => Number(item.num));
      let max = Math.max(...TData);
      let dataShadow = [];
      for (let i = 0; i < dataArr.length; i++) {
        dataShadow.push((max * 100 + 100) / 100); //最大值+1
      }
      let leftWidth = this.transformFontSize(18);
      let rightWidth = this.transformFontSize(8);
      option = {
        grid: { height: 300 },
        xAxis: { data: ["one", "two"] },
        yAxis: { type: "value" },
        series: [
          {
            type: "custom",
            renderItem: function(params, api) {
              let location = api.coord([api.value(0), api.value(1)]);
              return {
                type: "group",
                children: [
                  {
                    type: "MyCubeRect",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                    },
                    style: { fill: "#5AD8A6" },
                  },
                  {
                    type: "MyCubeShadow",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                    },
                    style: { fill: "#2DCF8E" },
                  },
                ],
              };
            },
            data: [20, 60],
          },
        ],
      };
      const CubeLeft = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function(ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c0 = [shape.x, shape.y];
          const c1 = [shape.x - leftWidth, shape.y - 4];
          const c2 = [xAxisPoint[0] - leftWidth, xAxisPoint[1] - 4];
          const c3 = [xAxisPoint[0], xAxisPoint[1]];
          ctx
            .moveTo(c0[0], c0[1])
            .lineTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .closePath();
        },
      });
      const CubeRight = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function(ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c1 = [shape.x - 5, shape.y];
          const c2 = [xAxisPoint[0] - 5, xAxisPoint[1]];
          const c3 = [xAxisPoint[0] + rightWidth, xAxisPoint[1] - 4];
          const c4 = [shape.x + rightWidth, shape.y - 4];
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath();
        },
      });
      const CubeTop = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0,
        },
        buildPath: function(ctx, shape) {
          // 逆时针 角 y 负数向上  X 负数向左
          const c1 = [shape.x - 5, shape.y];
          const c2 = [shape.x + rightWidth, shape.y - 4];
          const c3 = [shape.x - 5, shape.y - 8];
          const c4 = [shape.x - leftWidth, shape.y - 4];
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath();
        },
      });
      echarts.graphic.registerShape("CubeLeft", CubeLeft);
      echarts.graphic.registerShape("CubeRight", CubeRight);
      echarts.graphic.registerShape("CubeTop", CubeTop);
      let option = {
        // backgroundColor: "#080b30",
        title: {
          show: false,
          text: "梯龄分布",
          textStyle: {
            align: "center",
            color: "#fff",
            fontSize: 20,
          },
          top: "3%",
          left: "center",
        },
        grid: {
          left: 0,
          right: 0,
          top: "15%",
          bottom: "15%",
          containLabel: false,
        },
        tooltip: {
          formatter: "{b}: {c}" + unit,
        },
        xAxis: [
          {
            type: "category",
            data: dataArr.map((item) => item.name),
            axisLabel: {
              show: true,
              interval: 0,
              // rotate: dataArr.length > 5 ? 15 : 0, //数据大于5条时切斜显示
              color: "#A2BCC9",
              fontSize: this.transformFontSize(14),
              align: "center",
              // padding: dataArr.length > 5 ? [30, 0, 0, -24] : [0, 0, 0, -24],
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(135,142,148,0.5)",
              },
            },
          },
        ],
        yAxis: {
          show: false,
          type: "value",
          name: "单位（" + unit + "）",
          nameTextStyle: {
            fontSize: 14,
            color: "#9ca2a8",
            padding: [0, 0, 10, -30],
          },
          scale: false,
          axisLabel: {
            show: false,
            color: "#a0a5ab",
            fontSize: 12,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "rgba(255,255,255,.1)",
            },
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            backgroundStyle: "transparent",
            type: "custom",
            zlevel: 2,
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              let cubeLeftStyle = "";
              let cubeRightStyle = "";
              let cubeTopStyle = "";
              if (params.dataIndex % 2 == 0) {
                cubeLeftStyle = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0.4,
                    color: "#1d726c",
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)",
                  },
                ]);
                cubeRightStyle = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0.4,
                    color: "#78d2ce", // 顶部
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)", // 底部
                  },
                ]);
                cubeTopStyle = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#49b7b8",
                  },
                  {
                    offset: 1,
                    color: "#49b7b8",
                  },
                ]);
              } else {
                cubeLeftStyle = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0.4,
                    color: "#006f8e",
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)",
                  },
                ]);
                cubeRightStyle = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0.4,
                    color: "#23b1e6", // 顶部
                  },
                  {
                    offset: 1,
                    color: "rgba(0,0,0,0)", // 底部
                  },
                ]);
                cubeTopStyle = new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#4fc3ef",
                  },
                  {
                    offset: 1,
                    color: "#4fc3ef",
                  },
                ]);
              }
              return {
                type: "group",
                children: [
                  {
                    type: "CubeLeft",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: cubeLeftStyle,
                    },
                  },
                  {
                    type: "CubeRight",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: cubeRightStyle,
                    },
                  },
                  {
                    type: "CubeTop",
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: cubeTopStyle,
                    },
                  },
                ],
              };
            },
            data: TData,
          },
          {
            type: "bar",
            label: {
              normal: {
                show: true,
                position: "top",
                distance: 10,
                fontSize: this.transformFontSize(15),
                color: "#fff",
              },
            },
            barWidth: 20,
            itemStyle: {
              color: "transparent",
            },
            data: TData,
          },
          {
            type: "bar",
            itemStyle: {
              borderWidth: "0",
              borderColor: "rgba(151,175,88,0.5)",
              color: "rgba(0,0,0,0)",
            },
            barWidth: 20 * 2.4,
            barGap: "-155%",
            tooltip: {
              show: false,
            },
            cursor: "default",
            data: dataShadow,
            animation: false,
          },
        ],
      };
      let chartDom = document.getElementById("liftage-custom-box");
      this.liftageChart = this.liftageChart || echarts.init(chartDom);
      option && this.liftageChart.setOption(option);
      resize && this.liftageChart.resize();
    },
    setTiringMapRender(resize) {
      if (this.mapViewType.code == "china") {
        this.mapMaintain = true;
        // let chinaMap = require("../../assets/static/map-china.json");
        // echarts.registerMap("china", chinaMap);
      } else this.mapMaintain = false;
      if (this.mapMaintain) return false;
      let chartDom = document.getElementById("tiring-map-box");
      this.tiringMapChart = echarts.init(chartDom);
      if (this.mapViewType.code.includes("市")) {
        const city = require(`../../assets/static/${this.mapViewType.code}.json`);
        echarts.registerMap(this.mapViewType.code, city);
      }
      let option = {
        // backgroundColor: "#000f1e",
        tooltip: {
          trigger: "item",
          formatter: function(params) {
            if (params.componentSubType == "effectScatter") {
              const { domainName, name, province } = params.data;
              return `<span>${province || "--"}</span><br/>
              <span>${name || "--"}</span><br/>
              <span>${domainName || "--"}</span>`;
            }
          },
          extraCssText: "font-size:0.75rem;",
          backgroundColor: "rgba(11,34,66,0.76)",
        },
        geo: {
          map: this.mapViewType.code,
          aspectScale: 0.85,
          layoutCenter: ["50%", "50%"], //地图位置
          layoutSize: "100%",
          zoom: this.mapViewType.code == "china" ? 1.23 : 1,
          itemStyle: {
            normal: {
              shadowColor: "#276fce",
              shadowOffsetX: 0,
              shadowOffsetY: 15,
              opacity: 0.5,
            },
            emphasis: {
              areaColor: "#276fce",
            },
          },
          regions: [
            {
              name: "南海诸岛",
              itemStyle: {
                areaColor: "rgba(0, 10, 52, 1)",
                borderColor: "rgba(0, 10, 52, 1)",
                normal: {
                  opacity: 0,
                  label: {
                    show: false,
                    color: "#009cc9",
                  },
                },
              },
              label: {
                show: false,
                color: "#FFFFFF",
                fontSize: 12,
              },
            },
          ],
        },
        grid: {
          bottom: "0",
          right: "0",
          top: "0",
          left: "0",
        },
        series: [
          // 常规地图
          {
            type: "map",
            mapType: this.mapViewType.code,
            aspectScale: 0.85,
            layoutCenter: ["50%", "50%"], //地图位置
            layoutSize: "100%",
            zoom: this.mapViewType.code == "china" ? 1.23 : 1, //当前视角的缩放比例
            // roam: true, //是否开启平游或缩放
            scaleLimit: {
              //滚轮缩放的极限控制
              min: 1,
              max: 2,
            },
            itemStyle: {
              normal: {
                // areaColor: "#0c274b",
                areaColor: "#002a4e",
                borderColor: "#1cccff",
                borderWidth: 1.5,
              },
              emphasis: {
                areaColor: "#02102b",
                label: {
                  color: "#fff",
                },
              },
            },
            label: {
              show: true,
              color: "#FFFFFF",
              fontSize: this.transformFontSize(15),
            },
          },
          // 区域散点图
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 2,
            symbolSize: (rawValue, params) => {
              let size = [19, 17, 15, 13, 11, 9, 7, 5, 3, 1];
              return size[params.dataIndex];
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            label: {
              normal: {
                show: false,
                position: "right",
                formatter: "{b}",
                color: "#b3e2f2",
                fontWeight: "bold",
                fontSize: 18,
              },
            },
            data: this.mapWarningData,
            itemStyle: {
              //坐标点颜色
              normal: {
                show: true,
                color: "#F4E925",
                shadowBlur: 10,
                shadowColor: "#05C3F9",
              },
              emphasis: {
                areaColor: "#f00",
              },
            },
          },
          {
            type: "effectScatter",
            coordinateSystem: "geo",
            zlevel: 2,
            symbolSize: (rawValue, params) => {
              let size = [19, 17, 15, 13, 11, 9, 7, 5, 3, 1];
              return size[params.dataIndex];
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke",
            },
            hoverAnimation: true,
            label: {
              normal: {
                show: false,
                position: "right",
                formatter: "{b}",
                color: "#b3e2f2",
                fontWeight: "bold",
                fontSize: 18,
              },
            },
            data: this.mapTiringData,
            itemStyle: {
              //坐标点颜色
              normal: {
                show: true,
                color: "#ff9f67",
                shadowBlur: 10,
                shadowColor: "#fda369",
              },
              emphasis: {
                areaColor: "#f00",
              },
            },
          },
        ],
      };
      this.tiringMapChart.setOption(option, true);
      resize && this.tiringMapChart.resize();
    },
    /* 获取无纸化保养记录 */
    getDateMaintainRecordDate() {
      const cacheKey = "maintainDataCache";
      const cacheData = sessionStorage.getItem(cacheKey);
      if (cacheData) {
        const values = cacheData.split("#");
        if (values[1] == this.$common.formatDate(this.calenderDate.$DATE.$d)) {
          this.calenderDate.ds = JSON.parse(values[0]);
          return;
        } else {
          sessionStorage.removeItem(cacheKey);
        }
      }
      this.calendarLoading = true;
      this.$http
        .post(this.$apiConfig.get_elevator_maintain_record_date_url, {
          startDate: this.calenderDate.ds[0].date,
          endDate: this.calenderDate.ds[this.calenderDate.ds.length - 1].date,
        })
        .then((response) => {
          let result = response.data;
          this.calendarLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          data.forEach((v) => {
            let index = this.calenderDate.ds.findIndex((t) => t.date == v.date);
            if (index != -1) {
              this.calenderDate.ds[index].planOrFinish = v.values;
            }
          });
          sessionStorage.setItem(
            cacheKey,
            JSON.stringify(this.calenderDate.ds) + "#" + this.$common.formatDate(this.calenderDate.$DATE.$d),
            { expires: 1 }
          );
        })
        .catch((error) => {
          this.calendarLoading = false;
          this.$sentry.captureException(error);
        });
    },
    /* 获取遥监设备状态 */
    statisticsMonitorStatusCount() {
      this.$http
        .post(this.$apiConfig.statistics_device_status_count_url, {
          type: 2,
        })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let monitorStatusArr = result.data;
          let tol = 0;
          monitorStatusArr.forEach((t) => {
            if (Number(t.name) == 1) {
              this.monitorStatusData.normal.value = t.value;
            } else this.monitorStatusData.abnormal.value = t.value;
            tol += Number(t.value);
          });
          const { normal, abnormal } = this.monitorStatusData;
          let normalC = (normal.value / tol) * 100;
          let abnormalC = (abnormal.value / tol) * 100;
          this.monitorStatusData.normal.centage = normalC.toFixed(2) + "%";
          this.monitorStatusData.abnormal.centage = abnormalC.toFixed(2) + "%";
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* 获取遥监预警排行 */
    getMonitorWarningTop() {
      this.warningtopLoading = true;
      this.$http
        .post(this.$apiConfig.statistics_yesterdy_stop_fault_count_url, {
          pageNum: 1,
          pageSize: 20,
          statisticType: 1,
        })
        .then((response) => {
          let result = response.data;
          this.warningtopLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data.result;
          data.length = data.length > 3 ? 3 : data.length;
          this.monitorWarningTop3 = data.map((t) => {
            return {
              city: t.city,
              liftCount: t.liftCount,
              domainName: t.domainName,
              faultCount: t.faultCount,
              domainId: t.domainId,
            };
          });
        })
        .catch((error) => {
          this.warningtopLoading = false;
          this.$sentry.captureException(error);
        });
    },
    /* 获取设备巡视总汇 */
    getDeviceTourData() {
      this.$http
        .post(this.$apiConfig.statistics_elevator_status_count_url, { type: 1 })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          data.forEach((t) => {
            let i = this.deviceCollects.findIndex((v) => v.type == t.name);
            if (i != -1) {
              this.deviceCollects[i].number = t.value;
            }
          });
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* 获取合同提醒 */
    getContractRemind() {
      this.contractLoading = true;
      this.$http
        .post(this.$apiConfig.search_contract_expire_list_url, {
          pageNum: 1,
          pageSize: 12,
          curDate: this.$common.formatDate(new Date()),
          expiryInterval: 3 * 30,
        })
        .then((response) => {
          let result = response.data;
          this.contractLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data.result;
          this.contractRemindList = data.map((v) => {
            return {
              agreeNum: v.agreeNum,
              city: v.city,
              domainName: v.domainName,
              utils: v.utils,
              days: v.days,
            };
          });
        })
        .catch((error) => {
          this.contractLoading = false;
          this.$sentry.captureException(error);
        });
    },
    /* 获取年检提醒 */
    getAnnualExamineRemind() {
      this.annualLoading = true;
      this.$http
        .post(this.$apiConfig.search_year_cheak_list_url, {
          pageNum: 1,
          pageSize: 12,
          curDate: this.$common.formatDate(new Date()),
          expiryInterval: 3 * 30,
        })
        .then((response) => {
          let result = response.data;
          this.annualLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data.result;
          this.annualExamineRemindList = data.map((v) => {
            return {
              agreeNum: v.agreeNum,
              city: v.city,
              domainName: v.domainName,
              utils: v.utils,
              domainId: v.domainId,
            };
          });
        })
        .catch((error) => {
          this.annualLoading = false;
          this.$sentry.captureException(error);
        });
    },
    /* 获取实时关注列表 */
    getRealTimeFollowList() {
      this.$http
        .post(this.$apiConfig.search_real_elevator_fault_url, {})
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          this.realTimeFollowList = data.map((t) => {
            return {
              ...t,
              time: dayjs(t.updateTime).format("HH:mm"),
              domainName: t.domainName.trim().length > 15 ? t.domainName.substring(0, 15) + "..." : t.domainName,
            };
          });
          this.getFollowItemScrollHeight(1);
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    getFollowItemScrollHeight(type) {
      this.$nextTick(() => {
        // this.$refs.realtimeScroll?._stopMove();
        let scroll = document.getElementsByClassName("realtime-info-item");
        if (scroll && scroll.length != 0 && [undefined, 1].includes(type)) {
          let height = scroll[0]?.getBoundingClientRect()?.height;
          // for (let i = 0; i < scroll.length; i++) {
          //   if (scroll[i].offsetHeight > height) {
          //     console.log(scroll[i]);
          //     height = scroll[i].offsetHeight;
          //   }
          // }
          this.singleRealtimeHeight = height;
          console.log("singleRealtimeHeight", this.singleRealtimeHeight);
          // this.$refs.realtimeScroll?._startMove();
          //error vue-seamless-scroll
        }
        let mapScroll = document.getElementsByClassName("warning-map-item");
        if (mapScroll && mapScroll.length != 0 && [undefined, 2].includes(type)) {
          let heightScroll = mapScroll[0]?.getBoundingClientRect()?.height;
          this.singleMapHeight = heightScroll;
          console.log("singleMapHeight", this.singleMapHeight);
        }
      });
    },
    /* 获取梯龄分布 */
    getLiftageData() {
      let liftAge = sessionStorage.getItem("elevatorAgeBarData");
      if (!!liftAge) {
        const arr = liftAge.split("#");
        if (arr[0] == this.$common.formatDate()) {
          this.liftageData = JSON.parse(arr[1]);
          this.setLiftageCustomData();
          return;
        } else {
          sessionStorage.removeItem("elevatorAgeBarData");
        }
      }
      this.$http
        .post(this.$apiConfig.statistics_elevator_age_count_url, {
          curDate: this.$common.formatDate(new Date()),
        })
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          this.liftageData = data;
          this.setLiftageCustomData();
          sessionStorage.setItem("elevatorAgeBarData", this.$common.formatDate() + "#" + JSON.stringify(data));
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* 获取地图数据 */
    getWarningandTiringMapData(isNoLoading) {
      if (!isNoLoading) this.mapLoading = true;
      this.$store.state.indexMapTimer = setTimeout(() => {
        this.getWarningandTiringMapData(true);
      }, window.config.displayScreenCloseTimerInterval);
      this.$http
        .get(this.$apiConfig.statistics_fault_map_url)
        .then((response) => {
          let result = response.data;
          this.mapLoading = false;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          // data.city = "济南市";
          let { partData, allData, rangeType, province, city } = data;
          this.mapTiringData = partData
            .filter((t) => t.processType)
            .map((v) => {
              return {
                name: v.city,
                value: [v.longitude, v.latitude],
                domainName: v.domainName,
                province: v.province,
              };
            });
          this.mapWarningData = partData
            .filter((t) => !t.processType)
            .map((v) => {
              return {
                name: v.city,
                value: [v.longitude, v.latitude],
                domainName: v.domainName,
                province: v.province,
              };
            });
          if (city && city.includes("市")) {
            this.mapViewType.name = city;
            this.mapViewType.code = city;
          } else if (!!rangeType) {
            this.mapViewType.name = province;
            this.mapViewType.code = this.initImportFile();
          } else {
            this.mapViewType.name = "全国";
            this.mapViewType.code = "china";
          }
          this.mapAllCicyData = Object.keys(allData)
            .map((v) => {
              let n = v;
              if (!!rangeType) {
                let mapaArr = v.split(",");
                n = mapaArr[mapaArr.length - 1];
              }
              return {
                name: n,
                value: allData[v],
              };
            })
            .sort((a, b) => a.value - b.value);
          this.mapAllCicyData = Array.from(new Set([...this.mapAllCicyData]));
          this.showWarnings && this.openShowWarning();
          this.$nextTick(() => {
            this.setTiringMapRender();
          });
        })
        .catch((error) => {
          console.log(error);
          this.mapLoading = false;
          this.$sentry.captureException(error);
        });
    },
    initImportFile() {
      let filaName = {
        浙江: "zhejiang.js",
        安徽: "anhui.js",
        澳门: "aomen.js",
        北京: "beijing.js",
        重庆: "chongqing.js",
        福建: "fujian.js",
        甘肃: "gansu.js",
        广东: "guangdong.js",
        广西: "guangxi.js",
        贵州: "guizhou.js",
        海南: "hainan.js",
        河北: "hebei.js",
        黑龙江: "heilongjiang.js",
        河南: "henan.js",
        湖北: "hubei.js",
        湖南: "hunan.js",
        江苏: "jiangsu.js",
        江西: "jiangxi.js",
        吉林: "jilin.js",
        辽宁: "liaoning.js",
        内蒙古: "neimenggu.js",
        宁夏: "ningxia.js",
        青海: "qinghai.js",
        山东: "shandong.js",
        上海: "shanghai.js",
        山西: "shanxi.js",
        陕西: "shanxi1.js",
        四川: "sichuan.js",
        台湾: "taiwan.js",
        天津: "tianjin.js",
        香港: "xianggang.js",
        新疆: "xinjiang.js",
        西藏: "xizang.js",
        云南: "yunnan.js",
      };
      let name = this.mapViewType.name.replace("省", "");
      let name2 = name
        .replace("市", "")
        .replace("壮族自治区", "")
        .replace("回族自治区", "")
        .replace("维吾尔自治区", "")
        .replace("自治区", "");
      require(`../../../node_modules/echarts/map/js/province/${filaName[name2]}`);
      return name2;
    },
    openShowWarning() {
      this.showWarnings = true;
      this.getFollowItemScrollHeight(2);
      this.mapAllScrollData = this.mapAllCicyData;
    },
    cancelShowWarning() {
      this.showWarnings = false;
      this.mapAllScrollData = [];
    },
    /* 获取今日救援进度 */
    getRescueProgressData() {
      this.$http
        .post(this.$apiConfig.get_elevator_rescue_progress_url)
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          const { maintain, rescue } = data;
          let maintainProgress = [
            1,
            1,
            maintain[0] ? Number((maintain[2] / maintain[0]).toFixed(2)) : 1,
            maintain[0] ? Number((maintain[3] / maintain[0]).toFixed(2)) : 1,
          ];
          let rescueProgress = [
            1,
            1,
            rescue[0] ? Number((rescue[2] / rescue[0]).toFixed(2)) : 1,
            rescue[0] ? Number((rescue[3] / rescue[0]).toFixed(2)) : 1,
          ];
          this.rescueProgress.maintain.number = maintain;
          this.rescueProgress.maintain.progress = maintainProgress;
          this.rescueProgress.rescue.number = rescue;
          this.rescueProgress.rescue.progress = rescueProgress;
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    /* 获取运行次数分布统计 */
    getRunTimeStatData() {
      this.$http
        .post(this.$apiConfig.get_run_times_distribute_url)
        .then((response) => {
          let result = response.data;
          if (result.code != 0) return console.error(result.msg);
          let data = result.data;
          this.runTimePieData.forEach((t, i) => {
            t.value = data[`count${i + 1}`];
          });
          this.setRunTimePieData();
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
  },
  beforeDestroy() {
    window.clearTimeout(this.$store.state.indexMapTimer);
    this.$store.state.indexMapTimer = -1;
  },
};
</script>

<style scoped lang="scss">
.tip {
  min-width: 180px;
  width: vw(180);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  .en-end {
    display: flex;
    span:last-child {
      flex: 1;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  p {
    .en-class {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
    }

    text-align: right;
    width: 100%;
    position: relative;
    font-size: 1.125rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 500;
    font-style: italic;
    color: #d1d6df;
    padding-bottom: 10px;
    background: linear-gradient(0deg, #acddff 0%, #ffffff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    // text-shadow: 1px 1px 1px #ddd;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: url(../../assets/img/largeScreen/largeScreenTip.png) no-repeat;
    }
  }
}
.tip-plus {
  width: 100%;
  p {
    text-align: left;
    padding-left: 20px;
    display: flex;
    justify-content: space-between;
  }
  .en-class {
    width: auto !important;
  }
  p::after {
    background-image: url(../../assets/img/largeScreen/largeScreenTipPlus.png);
  }
}
.tip-plus-bottom {
  width: 100% !important;
  p {
    height: vh(40);
    text-align: left;
    padding-left: 40px;
    line-height: 40px;
    padding-bottom: 0;
    font-family: AlibabaPuHuiTi;
    font-size: 1.5rem;
    font-weight: 700;
    font-style: italic;
    color: #f6f9fe;
    background-image: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 100%);
  }
  p::after {
    background-image: url(../../assets/img/largeScreen/largeScreenTipLBootom.png);
  }
}
.tip-right {
  p {
    padding-right: 20px;
  }
  span {
    float: right;
    font-size: 1rem;
  }
  i {
    font-size: 1rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #b2d76a;
    -webkit-text-fill-color: #b2d76a;
    font-style: initial;
  }
}
.screen-main {
  flex: 1;
  position: relative;
  background: url(../../assets/img/largeScreen/largeScreenMapBgc.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  padding: vh(30) vw(15) 0 vw(15);
}
.main-left,
.main-right {
  width: vw(465);
  min-width: 410px;
  border-radius: 8px 8px 0 0;
  background-color: rgba(5, 25, 53, 0.6);
  padding: vh(15) vw(15) vh(15) vw(15);
  display: flex;
  flex-direction: column;
}
.main-right {
  min-width: 350px;
}
.main-map {
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}
.maintain-record {
  .title {
    display: flex;
    justify-content: space-between;
    margin-bottom: vh(5);
  }
  .tip {
    min-width: 145px;
    width: vw(145);
    p::after {
      min-width: 180px;
      width: vw(180);
    }
  }
  .change {
    display: flex;
    padding-bottom: vh(15);
    border-bottom: 2px solid #68c4f3;
    .btn {
      margin-left: vw(55);
      display: flex;
      justify-content: center;
      align-items: center;
      background: url(../../assets/img/largeScreen/dateBgc.png) no-repeat;
      background-position: center;
      background-size: contain;
      span {
        font-size: 1rem;
        font-family: DINCond-Bold;
        margin: 0 vw(10);
        color: #c6dcee;
        position: relative;
      }
      .svg-icon {
        fill: #c6dcee;
        width: 1rem;
        height: 1rem;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .already {
    width: vw(105);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 0.857rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 500;
    letter-spacing: 1px;
    color: #88ccff;
    padding-bottom: vh(10);
    border-bottom: 2px solid #68c4f3;
    span {
      background: url(../../assets/img/largeScreen/dateBgc.png) no-repeat;
      background-position: center;
      background-size: contain;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    span:last-child {
      color: #58eece;
      .svg-icon {
        fill: #14e6b2;
      }
    }
    .svg-icon {
      fill: #2f9bff;
      width: 0.857rem;
      height: 0.857rem;
    }
  }
  .calendar {
    height: vh(425);
    border: 2px solid #41f9ff;
    box-shadow: 0px 0px 20px 1px #1eaae766, inset 0px 0px 20px 6px #1eaae766;
    display: flex;
    flex-direction: column;
    .calendar-title {
      height: vh(40);
      background: #047bb7;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-bottom: 1px solid #10476e9e;
      box-shadow: 0px 2px 0px 0px #187695;
      span {
        font-family: JiangChengXieHei;
        font-weight: 700;
        color: #ecf4ff;
        font-size: 0.75rem;
      }
    }
    .calendar-table {
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      padding-top: 2px;
      .activate {
        background: #1eaae766;
        border: 2px solid #00ffff;
        box-shadow: 0px 0px 20px 1px #1eaae766, inset 0px 0px 20px 6px #1eaae766;
      }
    }
    .calendar-item {
      width: 14.2857%;
      padding-left: vw(10);
      // padding-top: vh(10);
      justify-content: center;
      display: flex;
      flex-direction: column;
      border-right: 1px solid #183f63;
      border-bottom: 1px solid #183f63;
      i {
        font-size: 1rem;
        font-style: normal;
        font-family: DINCond-BoldAlternate;
        color: #cbdfef;
      }
      span {
        font-family: DINCond-BoldAlternate;
        // font-size: 1.25rem;
        font-size: 1.1875rem;
        color: #0ef7bf;
      }
      em {
        color: #5db5f4;
      }
    }
    .ash {
      span,
      i {
        opacity: 0.3;
      }
    }
  }
}
.degree-pie {
  margin: vh(15) 0;
  display: flex;
  flex-direction: column;
  .pie {
    margin-top: vh(5);
    height: vh(95);
    display: flex;
    align-items: center;
    margin: vh(5) vw(8) 0;
  }
  /deep/.pie-box {
    width: vh(80);
    height: vh(80);
    margin-right: vw(20);
    position: relative;
    & > div {
      z-index: 2;
    }
    &::after {
      z-index: 1;
      content: "";
      position: absolute;
      width: vh(100);
      height: vh(100);
      top: 50%;
      left: 50%;
      transform: translate(-49.5%, -50%);
      background: url(../../assets/img/largeScreen/largeScreenMapPieBorder.png) no-repeat;
      background-size: 100%;
    }
  }
  .degree-label {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    div {
      position: relative;
      width: 50%;
      font-size: 0.875rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      color: #a4b3c5;
      padding: 0 vw(10) 0 vw(15);
      display: flex;
      justify-content: space-between;
      align-items: center;
      &:nth-child(2n) {
        padding-right: 0;
        padding-left: vw(30);
        i {
          left: vw(15);
        }
      }
    }
    i {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translate(0, -50%);
      width: vh(8);
      height: vh(8);
      border-radius: 1px;
    }
    em {
      font-size: 1.1rem;
      font-family: DINCond-BoldAlternate;
      font-weight: 400;
      color: #c2d7e8;
    }
  }
}
.device-state {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.percentage {
  flex: 1;
  flex-basis: 0;
  // height: vh(65);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 vw(8);
  .item-normal {
    padding-right: vw(20);
  }
  .item-abnormal {
    padding-right: vw(20);
    &::before {
      background-image: url(../../assets/img/largeScreen/abnormalIcon.png) !important;
    }
    span:first-child s {
      color: #f39664;
    }
  }
  .item-normal,
  .item-abnormal {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    width: 50%;
    &::before {
      content: "";
      width: vh(75);
      height: vh(75);
      background: url(../../assets/img/largeScreen/monitoIcon.png) no-repeat;
      background-size: 100%;
    }
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 1rem;
      color: #cedce6;
      span:last-child s {
        color: #798f9a;
      }
      i {
        font-style: normal;
      }
      s {
        text-decoration: none;
        font-size: 1.125rem;
        font-family: DINCond-Bold;
        color: #00dca6;
        margin-left: 5px;
      }
    }
  }
}
.monitoring-top {
  margin-top: vh(20);
  flex: 1;
  display: flex;
  flex-direction: column;
  .top-list {
    margin-top: vh(5);
    width: 95%;
    display: flex;
    flex-direction: column;
    border-top: 1px solid #577d9dad;
    flex: 1;
    flex-basis: 0;
    div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: vh(35);
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      font-style: normal;
      font-size: 0.875rem;
      color: #b9ccdf;
      padding: 0 vw(10);
      background-color: #01294f;
      border-bottom: 1px solid #163b5d;
      &:nth-child(2n) {
        background-color: #001c3f;
      }
      span {
        flex: 1;
        text-align: left;
        padding-left: vw(20);
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      i {
        font-style: normal;
        color: #99f17a;
      }
    }
    .no-data {
      height: 100%;
      justify-content: center;
    }
  }
  .top-list-contract {
    height: vh(110);
    overflow-y: auto;
    &::-webkit-scrollbar-thumb {
      /*    滚动条里面的小方块      */
      border-radius: 8px;
      // box-shadow: inset 0 0 5px #00000044;
      background: #69a5c6;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      box-shadow: inset 0 0 5px #00000044;
      border-radius: 0;
      background: #2c6392;
    }
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 4px;
    }
    div {
      min-height: vh(35);
      span {
        flex: 0.85;
        padding: 0;
        display: flex;
        font-family: inherit;
        font-weight: inherit;
        font-style: inherit;
        color: inherit;
      }
      s {
        text-decoration: none;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .top-list-annual {
    em {
      padding-left: 8px;
      margin-left: 5px;
      position: relative;
      &::before {
        content: "|";
        position: absolute;
        left: 0;
      }
    }
  }
}
.monitoring-top-right {
  margin-top: vh(20);
}
.realtime-info {
  margin-top: vh(20);
  display: flex;
  flex-direction: column;
  .info-list {
    width: 95%;
    padding-top: vh(3);
    .realtime-info-item {
      height: vh(42);
      display: flex;
      flex-direction: column;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      font-size: 0.875rem;
      font-style: italic;
      color: #b9ccdf;
      padding-right: 5px;
      div {
        height: 100%;
      }
    }

    span {
      color: #b9ccdf;
      opacity: 0.8;
      font-size: 0.75rem;
      text-align: right;
      float: right;
      margin-left: vw(60);
    }
  }
  .seamless-warp {
    height: vh(42);
    overflow: hidden;
  }
}
.map-fbox {
  flex: 1;
  position: relative;
  #tiring-map-box {
    width: 100%;
    height: 100%;
    .map-under {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: AlibabaPuHuiTi;
      font-weight: 400;
      color: #b8c6d3;
      font-size: 1rem;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #b8c6d3;
    font-size: 1rem;
  }
  .warning-list-box {
    position: absolute;
    top: 0;
    left: vw(36);
    height: 95%;
  }
  .warning-map-list {
    height: 100%;
    width: vw(285);
    background: rgba(5, 25, 53, 0.45);
    border: 1px solid rgba(64, 252, 255, 0.3);
    box-shadow: 4px 7px 13px 0px rgba(2, 19, 31, 0.36);
    border-radius: 6px;
    padding: vh(20) vw(10) 0 vw(20);
    display: flex;
    flex-direction: column;
    .tip p {
      text-align: left;
      padding-left: 20px;
    }
    .warning-list {
      flex: 1;
      overflow-y: auto;
      padding-top: vh(10);
      // &::-webkit-scrollbar {
      //   display: none;
      // }
      // scrollbar-width: none;
      // -ms-overflow-style: none;
      .warning-map-item {
        font-family: AlibabaPuHuiTi;
        font-weight: 400;
        color: #b8c6d3;
        font-size: 1rem;
        padding: vh(5) 0 vh(5) vw(20);
        display: flex;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          width: vw(7);
          height: vw(7);
          background: rgba(20, 220, 232, 0.78);
          top: 50%;
          left: vw(2);
          transform: translate(0, -50%) rotate(45deg);
          box-shadow: 0px 0px 5px #14dce894;
        }
      }
      label {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      span {
        flex-shrink: 0;
      }
    }
    .seamless-warning {
      height: 100%;
      overflow: hidden;
    }
    .footer {
      height: vh(40);
      i {
        float: right;
        width: vw(18);
        height: vh(25);
        background: url(../../assets/img/largeScreen/dropIcon.png) no-repeat;
        background-size: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &::before {
          content: "";
          display: inline-block;
          width: 1px;
          height: 1px;
          box-shadow: 0px 0px 20px 7px #14dce894;
        }
      }
    }
  }
  .suspension {
    width: vw(80);
    height: vw(80);
    background: url(../../assets/img/largeScreen/suspensionIcon.png) no-repeat;
    background-size: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #fff;
    font-size: 0.9375rem;
  }
  .tiring-map-label {
    position: absolute;
    right: vw(36);
    bottom: vh(200);
    width: vw(90);
    div {
      height: vh(36);
      display: flex;
      border-radius: 4px 4px;
      background: #000a20;
    }
    span {
      width: vh(38);
      border-radius: 4px;
      z-index: 2;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    label {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 500;
      color: #fffefd;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        left: -5px;
      }
    }
    .tiring {
      span {
        background-color: #dd8533;
      }
      label::after {
        background-image: linear-gradient(90deg, #50392dd6 0%, transparent 100%);
      }
      .svg-icon {
        width: 100%;
        height: 100%;
        fill: #fffff1;
      }
      margin-bottom: vh(24);
    }
    .warning {
      span {
        background-color: #e0de08;
      }
      label::after {
        background-image: linear-gradient(90deg, #454e19cf 0%, transparent 100%);
      }
      .svg-icon {
        width: 68%;
        height: 68%;
        fill: #fffff1;
      }
    }
  }
}
.rescue-progress {
  height: vh(270);
  display: flex;
  flex-direction: column;
  .rescue-view {
    flex: 1;
    padding: vh(15) 0;
    display: flex;
  }
  .rescue-items {
    width: 50%;
    display: flex;
    flex-direction: column;
  }
  .progress-box {
    width: vw(417);
    flex: 1;
    display: flex;
    padding-top: vh(10);
  }
  .bar-box {
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .progress-bar {
    height: vh(70);
    width: vh(70);
    position: relative;
    span {
      font-family: DINCond-Bold;
      font-weight: 400;
      color: #50e0ff;
      font-size: 1.4375rem;
    }
    &::before {
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
      width: vh(90);
      height: vh(90);
      background: url(../../assets/img/largeScreen/largeScreenProgressBgc.png) no-repeat;
      background-size: 100%;
    }
  }
  .decorate {
    width: 100%;
    height: vh(4);
    background: #23405b;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: vh(6);
      height: vh(6);
      background: #8185f1;
      border-radius: 1px;
    }
  }
  .text {
    font-size: 0.8125rem;
    font-family: AlibabaPuHuiTi;
    font-weight: 400;
    color: #cedce6;
    em {
      font-size: 1.25rem;
      font-family: DINCond-Bold;
      font-weight: 400;
      color: #0be1d9;
    }
  }
}
.tour-collect {
  display: flex;
  flex-direction: column;
  .collect-list {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
  }
  .collect-item {
    width: 50%;
    height: vh(65);
    display: flex;
    margin-bottom: vh(10);
    overflow: hidden;
  }
  .icon {
    width: vh(65);
    background-size: 100%;
    background-repeat: no-repeat;
    margin-right: vw(10);
    flex-shrink: 0;
  }

  em {
    font-size: 1.25rem;
    font-family: DINCond-Bold;
    font-weight: 400;
    color: #50e0ff;
    padding-left: vw(5);
  }
  .number {
    flex: 1;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    justify-content: center;
    overflow-y: hidden;
    & > span {
      width: 100%;
      overflow: hidden;
      width: 100%;
      // font-size: 1.125rem;
      font-size: 1.125rem;
      font-family: AlibabaPuHuiTi;
      font-weight: 500;
      font-style: italic;
      color: #d1d6df;
      position: relative;
      background: url(../../assets/img/largeScreen/collectTextBgc.png) no-repeat;
      background-size: 100%;
      padding-left: vw(5);
      &::after {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        text-wrap: nowrap;
        content: attr(data-title);
        display: inline-block;
        background: linear-gradient(0deg, #acddff 0%, #ffffff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}
.liftage-distribute {
  // margin: vh(15) 0;
  display: flex;
  flex-direction: column;
  .liftage-custom-box {
    height: vh(180);
  }
}
/deep/.custom-date-picker {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  &.el-input {
    width: 100%;
  }
  &.el-input--suffix {
    .el-input__inner {
      height: 100%;
    }
  }
  .el-input__inner {
    opacity: 0;
    padding: 0 !important;
    overflow: hidden;
  }
}
/deep/.date-screen {
  background-color: #052139;
  border-color: #1a364c;
  .el-picker-panel__icon-btn {
    color: #fff;
  }
  .popper__arrow {
    border-bottom-color: #0f4b70;
    &::after {
      border-bottom-color: #0f4b70;
    }
  }
  .cell {
    color: #e0edfe;
    font-size: 14px;
    &:hover {
      color: #2474bb;
    }
  }
  .el-date-picker__header {
    border-bottom: 0;
    background-color: #0f4b70;
    margin: 0;
    padding: 10px;
  }
  .el-picker-panel__content {
    margin: 0;
    width: 100%;
  }
  .today {
    background-color: #2474bb;
    .cell {
      color: #e0edfe;
    }
  }
  .current {
    .cell {
      color: #e0edfe !important;
    }
  }
  .el-date-picker__header-label {
    color: #e0edfe;
  }
}
</style>
